;(function() {
  'use strict'

  angular.module('core.wordcloud', [])
})()
